module.exports = __webpack_public_path__ + "img/bluetable.dac2e988.webp";